export const engagementAppGroupIdStructuralTemplateCanvasTemplateTags =
  "/engagement/:app_group_id/structural_template/canvas_template_tags";
